import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Home } from "../home";
import { About } from "../about";
import { Skills } from "../skills";
import { Services } from "../services";
import { Experience } from "../experience";
import { Portfolio } from "../portfolio";
import { ContactUs } from "../contact";

export const SinglePage = () => (
  <HelmetProvider>
    <Helmet>
      <meta charSet="utf-8" />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
    </Helmet>
    <div className="s_c">
      <Home />
      <About />
      <Skills />
      <Services />
      <Experience />
      <Portfolio />
      <ContactUs />
    </div>
  </HelmetProvider>
);
